import * as consts from './ModalsConsts';
import { sendEmailReq } from '../helpers/requestUtils';

export const changeModalVisibility = (name, value = undefined) => {
    return (dispatch, getState) => {
        const newName = name + 'IsOpen';
        if (value === undefined) {
            dispatch({
                type: consts.CHANGE_MODAL_VISIBILITY,
                payload: {
                    name: newName,
                    value: !getState().modals[newName]
                }
            });
        } else {
            dispatch({
                type: consts.CHANGE_MODAL_VISIBILITY,
                payload: {
                    name: newName,
                    value
                }
            })
        }
    }
}

export const sendEmail = (emails, fullname, ownEmail, message, unbranded, token) => {
    return (dispatch, getState) => {
        const { tourId, tourType } = getState().app;
        dispatch({type: consts.SEND_EMAIL_PENDING});

        sendEmailReq({
            recipient_emails: emails,
            sender_full_name: fullname,
            sender_email: ownEmail,
            sender_text_message: message,
            mode: unbranded ? 'unbranded' : tourType,
            //TODO we've only 'send_tour' option yet
            form_type: 'send_tour',
            token
        }, tourId).then(() => {
            dispatch({type: consts.SEND_EMAIL_FULFILLED});
        }, () => {
            dispatch({type: consts.SEND_EMAIL_REJECTED});
        });
    }
};
